import type { FC, PropsWithChildren } from "react";

import { type LinkWrapperProps, useLinkPrefetch } from "@jti/core-components/components/LinkBehaviour";

import { Link } from "@/libs/i18n";

export const NextLinkWrapper: FC<PropsWithChildren<LinkWrapperProps>> = ({ children, href, ...props }) => {
  const prefetch = useLinkPrefetch();
  // Only forward `prefetch` when it is explicitly set (e.g. `false` to defer prefetch for
  // collapsed navigation). Leaving it `undefined` preserves the Link's default prefetch handling.
  const prefetchProp = prefetch === undefined ? {} : { prefetch };

  if (!href) {
    // eslint-disable-next-line no-console
    console.warn("href is required for link");
    return <a {...props}>{children}</a>;
  }
  return (
    <Link
      href={href}
      {...prefetchProp}
      onNavigate={(e) => {
        // This is a workaround for the issue with Next.js, Cloudflare Worker and anchor links for coexisting pages.
        // When the link contains a hash (#) or query params and redirects to another page, it should not be handled by Next.js, but rather by the browser.
        // https://jira.jtiweb.co.uk/browse/DESP-94243 - example of the issue.
        // TODO: remove this workaround when there will be only Builder.
        const url = new URL(href, window.location.origin);

        if (
          url.origin === window.location.origin &&
          url.pathname !== window.location.pathname &&
          (url.hash || url.search)
        ) {
          window.location.href = href;
          e.preventDefault();
        }
      }}
      {...props}
    >
      {children}
    </Link>
  );
};
